"use client";

import { Loader2, Search, Star, TrendingUp } from "lucide-react";
import { getShanghaiDateContext } from "@/lib/agent/task-context";

function examples() {
  const { date } = getShanghaiDateContext();
  return [
    { icon: TrendingUp, label: "查看今天热搜", prompt: `查看 ${date} 的热搜` },
    { icon: Search, label: "统计人物今年上榜", prompt: "计算 C罗 今年上热搜的次数" },
    { icon: Star, label: "订阅一个关键词", prompt: "帮我订阅 C罗" },
  ];
}

export function AgentEmptyState({
  onPick,
  disabled = false,
}: {
  onPick: (prompt: string, position: number) => void;
  disabled?: boolean;
}) {
  const items = examples();
  return (
    <div className="flex h-full flex-col items-center justify-center px-4 py-8 text-center">
      <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-gradient-to-br from-sky-400 to-sky-600 text-white shadow-lg shadow-sky-500/25">
        <Search className="h-5 w-5" />
      </div>
      <h3 className="mt-4 text-base font-semibold text-slate-800 dark:text-slate-100">
        热搜 Agent
      </h3>
      <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
        自然语言查询历史热搜、统计上榜次数、订阅关键词。
      </p>
      <div className="mt-6 w-full space-y-2">
        {items.map((ex, index) => (
          <button
            key={ex.label}
            type="button"
            onClick={() => onPick(ex.prompt, index + 1)}
            disabled={disabled}
            className="flex w-full items-center gap-3 rounded-xl border border-slate-100 bg-white px-3.5 py-2.5 text-left transition hover:border-sky-200 hover:bg-sky-50/50 dark:border-slate-800 dark:bg-slate-900/40 dark:hover:border-sky-900/50 dark:hover:bg-sky-950/20"
          >
            <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-sky-50 text-sky-500 dark:bg-sky-950/40 dark:text-sky-400">
              <ex.icon className="h-4 w-4" />
            </span>
            <span className="min-w-0">
              <span className="block text-sm font-medium text-slate-700 dark:text-slate-200">{ex.label}</span>
              <span className="block truncate text-xs text-slate-400 dark:text-slate-500">{ex.prompt}</span>
            </span>
            <span className="ml-auto shrink-0 text-[11px] text-sky-600 dark:text-sky-400">
              {disabled ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : "立即执行"}
            </span>
          </button>
        ))}
      </div>
    </div>
  );
}
